import React, { PureComponent } from 'react';
import Proptypes from 'prop-types';
import { translate } from 'react-i18next';

import { Form } from 'common/components';
import moment from 'moment';

class AssetsFormNotesRow extends PureComponent {
  static propTypes = {
    note: Proptypes.shape({
      id: Proptypes.string.isRequired,
      text: Proptypes.string.isRequired,
      createdBy: Proptypes.shape({
        name: Proptypes.string,
        latname: Proptypes.string,
      }),
      createdAt: Proptypes.string.isRequired,
    }).isRequired,
  };

  handleRemove = (e) => {
    e && e.preventDefault();
    this.props.handleRemove(this.props.note.id);
  };

  render = () => (
    <tr>
      <td>{this.props.note.text}</td>
      <td>{moment(this.props.note.createdAt).format('DD/MM/YYYY')}</td>
      <td>
        {this.props.note.createdBy.name} {this.props.note.createdBy.lastname}
      </td>
      <td className="text-center">
        <Form.Button
          onClick={this.handleRemove}
          className="btn btn-danger btn-sm"
          text={this.props.t('actions.delete')}
        />
      </td>
    </tr>
  );
}

export default translate()(AssetsFormNotesRow);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormNotesRow.js